export { default as DATEPICKER_LOCALE } from 'date-fns/locale/fr';

export const EMOJI_LOCALE = {
    search: 'Rechercher',
    clear: 'Effacer',
    notfound: 'Pas d\'émoji trouvé',
    skintext: 'Choisissez votre couleur de peau',
    categories: {
        search: 'Rechercher les résultats',
        recent: 'Récemment utilisés',
        people: 'Smileys et personnes',
        nature: 'Animaux et nature',
        foods: 'Alimentation',
        activity: 'Activités',
        places: 'Lieux et voyages',
        objects: 'Objets',
        symbols: 'Symboles',
        flags: 'Drapeaux',
        custom: 'Custom',
    },
    categorieslabel: 'Catégories',
    skintones: {
        1: 'Couleur de peau par défaut',
        2: 'Couleur de peau 2',
        3: 'Couleur de peau 3',
        4: 'Couleur de peau 4',
        5: 'Couleur de peau 5',
        6: 'Couleur de peau 6',
    }
};

export const MOMENT_LOCALE = {
    months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact: true,
    weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact: true,
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[Aujourd\'hui à] LT',
        nextDay: '[Demain à] LT',
        nextWeek: 'dddd [à] LT',
        lastDay: '[Hier à] LT',
        lastWeek: 'dddd [dernier à] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'dans %s',
        past: 'il y a %s',
        s: 'quelques secondes',
        m: 'une minute',
        mm: '%d minutes',
        h: 'une heure',
        hh: '%d heures',
        d: 'un jour',
        dd: '%d jours',
        M: 'un mois',
        MM: '%d mois',
        y: 'un an',
        yy: '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal: (number) => number + (number === 1 ? 'er' : 'e'),
    meridiemParse: /PD|MD/,
    isPM: (input) => input.charAt(0) === 'M',
    // In case the meridiem units are not separated around 12, then implement
    // this function (look at locale/id.js for an example).
    // meridiemHour: function (hour, meridiem) {
    //     return /* 0-23 hour, given meridiem token and hour 1-12 */ ;
    // },
    meridiem: (hours, minutes, isLower) => hours < 12 ? 'PD' : 'MD',
    week: {
        // Monday is the first day of the week.
        dow: 1,
        // Used to determine first week of the year.
        doy: 4
    }
};
